import React from 'react';

/**
 * PositionLedgerRow - Single position row
 * Displays all fields matching Python ledger format
 */
function PositionLedgerRow({ position, isOption }) {
  const isClosed = position.status === 'closed';
  const isProfit = parseFloat(position.total_pnl_num || 0) >= 0;

  // Format price helper
  const fmtPrice = (val, width = 7) => {
    if (val === null || val === undefined || val === '-') return '-';
    const num = parseFloat(val);
    if (isNaN(num)) return '-';
    return num.toFixed(2);
  };

  // Format slippage helper
  const fmtSlip = (val) => {
    if (val === null || val === undefined) return '-';
    const num = parseFloat(val);
    if (isNaN(num)) return '-';
    return num.toFixed(4);
  };

  return (
    <tr className={`ledger-row ${isClosed ? 'closed-position' : 'active-position'}`}>
      {/* Status */}
      <td>
        <span className={`badge ${isClosed ? 'bg-secondary' : 'bg-success'}`}>
          {position.status.toUpperCase()}
        </span>
      </td>

      {/* Symbol */}
      <td className="fw-bold">{position.symbol}</td>

      {/* Option-specific columns */}
      {isOption && (
        <>
          <td>
            <span className={`badge ${position.option_type === 'call' ? 'bg-info' : 'bg-warning'}`}>
              {position.option_type?.toUpperCase()}
            </span>
          </td>
          <td>${position.strike}</td>
          <td className="small">{position.expiration}</td>
        </>
      )}

      {/* Direction & Quantity */}
      <td>
        <span className={position.direction === 'long' ? 'text-success' : 'text-danger'}>
          {position.direction?.toUpperCase()}
        </span>
      </td>
      <td>{position.quantity}</td>

      {/* Entry Details */}
      <td>${position.avg_entry_price}</td>
      <td className="small text-muted">{position.entry_filled_at}</td>
      <td className="small">{position.entry_order_type}</td>
      <td>{fmtPrice(position.entry_limit_price)}</td>
      <td className={parseFloat(position.entry_slippage || 0) > 0 ? 'text-danger' : 'text-success'}>
        {fmtSlip(position.entry_slippage)}
      </td>

      {/* Exit Details */}
      <td>{isClosed ? `$${fmtPrice(position.exit_fill_price)}` : '-'}</td>
      <td className="small text-muted">{position.exit_filled_at || '-'}</td>
      <td className="small">{position.exit_order_type || '-'}</td>
      <td>{isClosed ? fmtPrice(position.exit_limit_price) : '-'}</td>
      <td className={parseFloat(position.exit_slippage || 0) > 0 ? 'text-danger' : 'text-success'}>
        {isClosed ? fmtSlip(position.exit_slippage) : '-'}
      </td>

      {/* P&L */}
      <td className={`fw-bold ${isProfit ? 'text-success' : 'text-danger'}`}>
        ${position.total_pnl}
        {!isClosed && position.unrealized_pnl_num !== 0 && (
          <small className="d-block text-muted">
            (U: ${position.unrealized_pnl})
          </small>
        )}
      </td>

      {/* Bracket */}
      <td>{fmtPrice(position.rr, 4)}</td>
      <td>{fmtPrice(position.tp_limit)}</td>
      <td>{fmtPrice(position.sl_stop)}</td>
      <td>{fmtPrice(position.sl_limit)}</td>

      {/* Timing */}
      <td className="small">{position.hold_time || '-'}</td>
      <td className="small text-muted">{position.entry_submitted_at}</td>
    </tr>
  );
}

export default PositionLedgerRow;